import { useAurigaContext } from '@context/AurigaContext';
import { useUserContext } from '@context/UserContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Records a CloudWatch RUM load-complete event when the route's content has finished loading.
 * Pairs with the `startOnLoad` call in RouteTracker (AurigaLayout) to measure page load duration.
 *
 * @param isLoaded - Whether the route component considers its content fully loaded
 */
const useRecordLoadComplete = (isLoaded: boolean) => {
  const { username } = useUserContext();
  const { rumLogger } = useAurigaContext();
  const location = useLocation();

  // Emit the RUM load-complete event once when the route signals it has finished loading
  useEffect(() => {
    if (rumLogger && isLoaded) {
      rumLogger.recordLoadCompleteEvent(location.pathname + location.search, { userAlias: username });
    }
  }, [isLoaded, rumLogger, location, username]);
};

export default useRecordLoadComplete;
